var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoClose(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0664 1.99902C11.1627 1.99906 12.2141 2.43479 12.9893 3.20996C13.7644 3.98516 14.2002 5.03657 14.2002 6.13281V7.7998H15.3838C15.7978 7.80005 16.1338 8.13574 16.1338 8.5498V17.251C16.1335 17.6648 15.7976 18.0007 15.3838 18.001H4.74902C4.33502 18.001 3.99936 17.6649 3.99902 17.251V8.5498C3.99902 8.13559 4.33481 7.7998 4.74902 7.7998H5.93262V6.13281C5.93262 5.0365 6.36835 3.98517 7.14355 3.20996C7.91876 2.43475 8.9701 1.99902 10.0664 1.99902ZM5.49902 16.501H14.6338V9.2998H5.49902V16.501ZM10.0664 3.49902C9.36792 3.49902 8.69801 3.7766 8.2041 4.27051C7.7102 4.76441 7.43262 5.43433 7.43262 6.13281V7.7998H12.7002V6.13281C12.7002 5.43439 12.4225 4.7644 11.9287 4.27051C11.4348 3.77664 10.7648 3.49906 10.0664 3.49902Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoClose);
export default __webpack_public_path__ + "static/media/auto-close.cbda770a.svg";
export { ForwardRef as ReactComponent };